import React from "react";
import "./ruko1.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Melodyimages from "../../../media/Ruko/Melody/Melody";
import Edisonimages from "../../../media/Ruko/Edison/Edison";
import Faradayimages from "../../../media/Ruko/Faraday/Faraday";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faArrowsUpDownLeftRight,
  faBuilding,
  faLayerGroup,
  faMedal,
} from "@fortawesome/free-solid-svg-icons";

import {faShower} from "@fortawesome/free-solid-svg-icons";
import {faWhatsapp} from "@fortawesome/free-brands-svg-icons";

const ruko1 = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const EdisonWa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6285215127964&text=Halo%20Marketing%20Summarecon,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20produk%20Ruko%20Edison%20https://marketinggadingserpong.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  const FaradayWa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6285215127964&text=Halo%20Marketing%20Summarecon,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20produk%20Ruko%20Faraday%20https://marketinggadingserpong.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  const MelodyWa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6285215127964&text=Halo%20Marketing%20Summarecon,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20produk%20Ruko%20Melody%20https://marketinggadingserpong.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div id="ruko" className="container">
      <div className="containercard-ruko">
        <div className="card">
          <Slider {...settings}>
            {Faradayimages.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-rumah">
            <div className="nama-rumah">Faraday</div>
            <div className="gridmap">
              <FontAwesomeIcon
                className="icon"
                color="#C88C39"
                icon={faMedal}
              />
              <div className="namalokasi">Siap Huni, Free PPN</div>
            </div>
          </div>
          <hr />
          <div className="gridspek">
            <FontAwesomeIcon color="#334442" icon={faArrowsUpDownLeftRight} />
            <span> 80m²</span>
            <FontAwesomeIcon color="#334442" icon={faBuilding} />
            <span> 125m²</span>
            <FontAwesomeIcon color="#334442" icon={faLayerGroup} />
            <span> 3</span>
            <FontAwesomeIcon color="#334442" icon={faShower} />
            <span> 3</span>
          </div>
          <hr />
          <div className="containercicilan">
            <div className="judulkartu">
              <div className="startfrom">Start From</div>
            </div>
            <div className="cicilansumban">
              <div className="angka">15 Juta/Bulan</div>
            </div>
          </div>
          <div className="cluster-button">
            <button onClick={FaradayWa} className="cluster-whatsapp">
              <FontAwesomeIcon size="lg" icon={faWhatsapp} />
              &nbsp;Whatsapp
            </button>
          </div>
        </div>
        <div className="card">
          <Slider {...settings}>
            {Melodyimages.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-rumah">
            <div className="nama-rumah">Melody</div>
            <div className="gridmap">
              <FontAwesomeIcon
                className="icon"
                color="#C88C39"
                icon={faMedal}
              />
              <div className="namalokasi">Siap Huni, Free PPN</div>
            </div>
          </div>
          <hr />
          <div className="gridspek">
            <FontAwesomeIcon color="#334442" icon={faArrowsUpDownLeftRight} />
            <span> 100m²</span>
            <FontAwesomeIcon color="#334442" icon={faBuilding} />
            <span> 206m²</span>
            <FontAwesomeIcon color="#334442" icon={faLayerGroup} />
            <span> 3</span>
            <FontAwesomeIcon color="#334442" icon={faShower} />
            <span> 3</span>
          </div>
          <hr />
          <div className="containercicilan">
            <div className="judulkartu">
              <div className="startfrom">Start From</div>
            </div>
            <div className="cicilansumban">
              <div className="angka">16 Juta/Bulan</div>
            </div>
          </div>
          <div className="cluster-button">
            <button onClick={MelodyWa} className="cluster-whatsapp">
              <FontAwesomeIcon size="lg" icon={faWhatsapp} />
              &nbsp;Whatsapp
            </button>
          </div>
        </div>
        <div className="card">
          <Slider {...settings}>
            {Edisonimages.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-rumah">
            <div className="nama-rumah">Edison</div>
            <div className="gridmap">
              <FontAwesomeIcon
                className="icon"
                color="#C88C39"
                icon={faMedal}
              />
              <div className="namalokasi">Siap Huni</div>
            </div>
          </div>
          <hr />
          <div className="gridspek">
            <FontAwesomeIcon color="#334442" icon={faArrowsUpDownLeftRight} />
            <span> 77.5m²</span>
            <FontAwesomeIcon color="#334442" icon={faBuilding} />
            <span> 110m²</span>
            <FontAwesomeIcon color="#334442" icon={faLayerGroup} />
            <span> 3</span>
            <FontAwesomeIcon color="#334442" icon={faShower} />
            <span> 2</span>
          </div>
          <hr />
          <div className="containercicilan">
            <div className="judulkartu">
              <div className="startfrom">Start From</div>
            </div>
            <div className="cicilansumban">
              <div className="angka">10 Juta/Bulan</div>
            </div>
          </div>
          <div className="cluster-button">
            <button onClick={EdisonWa} className="cluster-whatsapp">
              <FontAwesomeIcon size="lg" icon={faWhatsapp} />
              &nbsp;Whatsapp
            </button>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default ruko1;
